import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '@abp/ng.core';
import { map, Observable } from 'rxjs';
import { TOUR_REPORT_PERMISSION_REDIRECT_TO } from '../constants/constants';

export const redirectPermissionGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const requiredPolicy = route.data?.['requiredPolicy'] as string;
  const redirectTo = route.data?.['redirectTo'] as string || TOUR_REPORT_PERMISSION_REDIRECT_TO; 

  if (!requiredPolicy) {
    return new Observable(observer => {
      observer.next(true);
      observer.complete();
    });
  }

  return permissionService.getGrantedPolicy$(requiredPolicy).pipe(
    map(hasPermission => {
      if (!hasPermission) {
        router.navigateByUrl(redirectTo);
        return false;
      }
      return true;
    })
  );
};
